module.exports = __webpack_public_path__ + "static/media/less.46a560ed.png";